export const ACTION_ADD_SITE_ALIASES = 'ACTION_ADD_SITE_ALIASES';

export const ACTION_CREATE_SITE_ALIAS__REQUEST = 'ACTION_CREATE_SITE_ALIAS__REQUEST';
export const ACTION_CREATE_SITE_ALIAS__SUCCESS = 'ACTION_CREATE_SITE_ALIAS__SUCCESS';
export const ACTION_CREATE_SITE_ALIAS__FAIL = 'ACTION_CREATE_SITE_ALIAS__FAIL';

export const ACTION_DELETE_SITE_ALIAS__REQUEST = 'ACTION_DELETE_SITE_ALIAS__REQUEST';
export const ACTION_DELETE_SITE_ALIAS__SUCCESS = 'ACTION_DELETE_SITE_ALIAS__SUCCESS';
export const ACTION_DELETE_SITE_ALIAS__FAIL = 'ACTION_DELETE_SITE_ALIAS__FAIL';
